var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "misFormRef", attrs: { model: _vm.misForm } },
        [
          _c("div", { staticClass: "route_rule_title" }, [
            _vm._v(_vm._s(_vm.$t("newOrder.BasicInformation"))),
          ]),
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap" },
              attrs: { type: "flex", justify: "left", gutter: 20 },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.mis4"),
                        prop: "ruleName",
                        rules: {
                          required: true,
                          message: _vm.$t("collectionCenter.mis15"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "textarea_class",
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t(
                            "collectionCenter.ruleNamePlaceholder"
                          ),
                          type: "textarea",
                          maxlength: 100,
                          "show-word-limit": "",
                          rows: "1",
                          clearable: "",
                          size: "medium",
                          disabled:
                            _vm.misTitle === _vm.$t("collectionCenter.mis11"),
                        },
                        model: {
                          value: _vm.misForm.ruleName,
                          callback: function ($$v) {
                            _vm.$set(_vm.misForm, "ruleName", $$v)
                          },
                          expression: "misForm.ruleName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.mis1"),
                        prop: "originHubId",
                        rules: {
                          required: true,
                          message: _vm.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("ElSelectV2", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.siteList,
                          placeholder: _vm.$t(
                            "collectionCenter.originTransitCenterPlaceholder"
                          ),
                          clearable: "",
                          filterable: "",
                          size: "medium",
                          "popper-class": "SelectV2_popper",
                          disabled:
                            _vm.misTitle === _vm.$t("collectionCenter.mis11"),
                        },
                        on: { change: _vm.ohChange },
                        model: {
                          value: _vm.misForm.originHubId,
                          callback: function ($$v) {
                            _vm.$set(_vm.misForm, "originHubId", $$v)
                          },
                          expression: "misForm.originHubId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.stateZT"),
                        prop: "status",
                        rules: {
                          required: true,
                          message: _vm.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            size: "medium",
                            disabled:
                              _vm.misTitle === _vm.$t("collectionCenter.mis11"),
                          },
                          model: {
                            value: _vm.misForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.misForm, "status", $$v)
                            },
                            expression: "misForm.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.enable"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.stop"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "route_rule_title" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.mis12"))),
          ]),
          _c(
            "div",
            { staticClass: "route_configuration" },
            [
              _c(
                "el-row",
                {
                  staticStyle: { gap: "10px" },
                  attrs: { type: "flex", justify: "left" },
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "route_c_col_box", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "route_c_col" }, [
                        _vm._v("① " + _vm._s(_vm.$t("collectionCenter.mis1"))),
                      ]),
                      _c("div", { staticClass: "route_c_bold" }, [
                        _vm._v(_vm._s(_vm.originHubName || "- -")),
                      ]),
                      _c("span", { staticClass: "route_c_grey" }, [
                        _vm._v(_vm._s(_vm.$t("collectionCenter.mis16"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "route_c_col_box", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "route_c_col" }, [
                        _vm._v("② " + _vm._s(_vm.$t("collectionCenter.mis17"))),
                      ]),
                      _vm._l(_vm.transitCenterData, function (item, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "route_tc_box" },
                          [
                            _c("div", { staticClass: "route_tc_idx" }, [
                              _vm._v(_vm._s(idx + 1)),
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  flex: "1",
                                  "margin-bottom": "0",
                                },
                                attrs: { prop: "transitCenterData." + idx },
                              },
                              [
                                _c("ElSelectV2", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.siteList,
                                    placeholder: _vm.$t(
                                      "collectionCenter.originTransitCenterPlaceholder"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    size: "medium",
                                    "popper-class": "SelectV2_popper",
                                    disabled:
                                      _vm.misTitle ===
                                      _vm.$t("collectionCenter.mis11"),
                                  },
                                  model: {
                                    value: _vm.misForm.transitCenterData[idx],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.misForm.transitCenterData,
                                        idx,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "misForm.transitCenterData[idx]",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                style: {
                                  visibility:
                                    _vm.transitCenterData.length > 1 &&
                                    _vm.misTitle !==
                                      _vm.$t("collectionCenter.mis11")
                                      ? "visible"
                                      : "hidden",
                                },
                                attrs: {
                                  type: "danger",
                                  plain: "",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(idx)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.Delete"))
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm.misTitle !== _vm.$t("collectionCenter.mis11")
                        ? _c(
                            "div",
                            {
                              staticClass: "add_btn",
                              on: { click: _vm.addItem },
                            },
                            [
                              _vm._v(
                                "+ " + _vm._s(_vm.$t("collectionCenter.mis18"))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "el-col",
                    { staticClass: "route_c_col_box", attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "deliverySiteIds",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.mis23"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "route_c_col" }, [
                            _vm._v(
                              "③ " + _vm._s(_vm.$t("GlobalSetObj.preEntrega"))
                            ),
                          ]),
                          _vm.misTitle === _vm.$t("collectionCenter.mis11") &&
                          _vm.cascaderList.length > 0
                            ? _c(
                                "div",
                                { staticClass: "cascader_text_box" },
                                _vm._l(_vm.cascaderList, function (item, idx) {
                                  return _c("span", { key: idx }, [
                                    _vm._v(_vm._s(item)),
                                  ])
                                }),
                                0
                              )
                            : _c("el-cascader", {
                                staticStyle: {
                                  width: "100%",
                                  "margin-top": "10px",
                                },
                                attrs: {
                                  options: _vm.siteData,
                                  props: {
                                    multiple: true,
                                    value: "value",
                                    label: "label",
                                  },
                                  clearable: "",
                                  filterable: "",
                                  "collapse-tags": "",
                                },
                                on: { change: _vm.handleChange },
                                model: {
                                  value: _vm.misForm.deliverySiteIds,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.misForm,
                                      "deliverySiteIds",
                                      $$v
                                    )
                                  },
                                  expression: "misForm.deliverySiteIds",
                                },
                              }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "cascader_msg" },
                        [
                          _c("span", { staticClass: "cascader_1" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("collectionCenter.mis19")) +
                                " " +
                                _vm._s(_vm.misForm.deliverySiteIds.length) +
                                " " +
                                _vm._s(_vm.$t("collectionCenter.mis20")) +
                                " "
                            ),
                          ]),
                          _vm._l(_vm.stateList, function (item, idx) {
                            return _c(
                              "span",
                              { key: idx, staticClass: "cascader_2" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(item.state) +
                                    " " +
                                    _vm._s(item.sum) +
                                    " " +
                                    _vm._s(_vm.$t("collectionCenter.mis21")) +
                                    " "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "cascader_3" }, [
                        _vm._v(_vm._s(_vm.$t("collectionCenter.mis14"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { staticClass: "route_box", attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "route_preview" }, [
                        _vm._v(_vm._s(_vm.$t("collectionCenter.mis22")) + "："),
                      ]),
                      _vm.routeData.origin ||
                      _vm.routeData.transits.length ||
                      _vm.routeData.deliveries.length
                        ? _c(
                            "div",
                            [
                              _vm.routeData.origin
                                ? [
                                    _c(
                                      "span",
                                      { staticClass: "tag_route tag-first" },
                                      [_vm._v(_vm._s(_vm.routeData.origin))]
                                    ),
                                    _vm.routeData.transits.length ||
                                    _vm.routeData.deliveries.length
                                      ? _c(
                                          "span",
                                          { staticClass: "arrow_separator" },
                                          [_vm._v("→")]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _vm.routeData.transits.length
                                ? [
                                    _vm._l(
                                      _vm.routeData.transits,
                                      function (item, index) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              key: "transit-" + index,
                                              staticClass:
                                                "tag_route tag-middle",
                                            },
                                            [_vm._v(_vm._s(item))]
                                          ),
                                          index <
                                          _vm.routeData.transits.length - 1
                                            ? _c(
                                                "span",
                                                {
                                                  key: "transit-arrow-" + index,
                                                  staticClass:
                                                    "arrow_separator",
                                                },
                                                [_vm._v("→")]
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                    _vm.routeData.deliveries.length
                                      ? _c(
                                          "span",
                                          { staticClass: "arrow_separator" },
                                          [_vm._v("→")]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _vm.routeData.deliveries.length
                                ? [
                                    _vm._l(
                                      _vm.routeData.deliveries,
                                      function (item, index) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              key: "delivery-" + index,
                                              staticClass: "tag_route tag-last",
                                            },
                                            [_vm._v(_vm._s(item))]
                                          ),
                                          index <
                                          _vm.routeData.deliveries.length - 1
                                            ? _c(
                                                "span",
                                                {
                                                  key:
                                                    "delivery-arrow-" + index,
                                                  staticClass:
                                                    "arrow_separator",
                                                },
                                                [_vm._v("→")]
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.misTitle !== _vm.$t("collectionCenter.mis11")
        ? _c(
            "div",
            { staticStyle: { "text-align": "right", margin: "20px 0" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "default_btn",
                  attrs: { size: "medium" },
                  on: { click: _vm.closeThis },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "blue_color_btn",
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.saveRule },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.mis13")))]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }